<template>
  <div class="custom-select">
    <select
      class="form-control"
      :name="name"
      :id="options[0].id + 'bundle-select'"
      :class="{
        'cl-tertiary' : options.length === 0,
        'empty': !selected
      }"
      :autocomplete="autocomplete"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      @change="$emit('change', $event.target.value)"
      @input="$emit('input', $event.target.value)"
    >
      <option :disabled="isOptionRequired ? true : false" selected value>
        <template v-if="isOptionRequired">
          Wybierz opcję
        </template>
        <template v-else>
          (+0zł) Bez prezentu
        </template>
      </option>
      <option v-for="opval in validOptions" :key="opval.id" :value="opval.id">
        {{ beautifyPrice(opval) }} {{ opval.product.name }}
      </option>
    </select>
    <label :for="options[0].id + 'bundle-select'" class="visually-hidden">{{ name }}</label>
    <ValidationMessages v-if="validations" :validations="validations" />
  </div>
</template>

<script>
import ValidationMessages from './ValidationMessages.vue'

export default {
  name: 'BundleSelect',
  components: {
    ValidationMessages
  },
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    selected: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    validations: {
      type: Array,
      default: () => []
    },
    isOptionRequired: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    beautifyPrice (product) {
      return product.price
        ? '(+' + product.price + ' zł)'
        : null
    }
  },
  computed: {
    validOptions () {
      return this.options.filter(opval => opval.product)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/base/text';
$color-main: color(main);

.custom-select {
  &::after {
    content: '';
    border: solid $color-main;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
    display: block;
    position: absolute;
    top: 20px;
    right: 20px;
    width: 0;
    height: 0;
    pointer-events: none;
  }
  position: relative;
  select {
    font: inherit;
    z-index: 2;
    text-transform: none;
    outline: none;
    &:focus {
      background:#F7F7F7;
      color: #000;
      border-width: 2px;
      border-color: #F7F7F7;
    }
    &:disabled,
    &:disabled + label {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  .form-control {
    display: block;
    font-size: 14px;
    color: #000;
    background: #F7F7F7;
    border: 2px solid #F7F7F7;
    border-radius: 30px;
    box-shadow: none;
    padding: 0 25px 0 25px;
    margin: 0px;
    width: 100%;
    box-sizing: border-box;
    line-height: 1.5;
    -webkit-appearance: none;
    -moz-appearance: none;
    min-height: 44px;
    transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease, border-radius 0.2s ease;
    option {
      font-size: 17px;
    }
  }
}
</style>
